export default function getQuery(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    let rel = '';
    if (r != null) {
        rel = r[2] || '';
    }
    return rel;
}
